var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    color: "#fff",
    viewBox: "0 0 90 128",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 68.409,
    y: 50.597,
    fontFamily: "'ArialMT','Arial',sans-serif",
    fontSize: 144,
    fontWeight: 600,
    transform: "translate(-65.542 62.973)"
  }, "$")));
}
export default SvgMoney;